import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { StadiumDto } from "app/models";
import { AttendanceService, ConfigurationService, NotificationService, StadiumService } from "app/services";

@Component({
    selector: 'next-fixture-stadium',
    templateUrl: './next-fixture-stadium.component.html',
    styleUrls: ['./next-fixture-stadium.component.scss'],
})
export class NextFixtureStadium implements OnInit {
    
    @Input() stadium: StadiumDto;

    @Input() canSetupPrice: boolean;

    @Input() homeTeamId: number;

    @Input() hidePrice: boolean;

    formGroup: FormGroup;

    baseFintUrl: string;

    prognoseAttendance: number = 0;
    prognoseRevenue: number = 0;
    prognosePercent: number = 0;

    isProcessing: boolean = false;

    constructor(private notificationService: NotificationService,
         private stadiumService: StadiumService,
         private attendanceService: AttendanceService,
         configurationService: ConfigurationService) {
        this.baseFintUrl = configurationService.getFintFMUrl();
    }

    ngOnInit(): void {
        this.buildForm();

        if (this.canSetupPrice)
            this.getPrognose();
        
    }

    setupPrice(isValid: boolean) {
        if (isValid) {
            this.isProcessing = true;
            this.stadiumService.setupPrice(this.formGroup.controls.priceFormControl.value)
                .subscribe(result => {
                    this.notificationService.showSuccess('Цена билета обновлена.');
                    this.stadium.price = this.formGroup.controls.priceFormControl.value;
                    this.isProcessing = false;
                });
        }
    }


    doPrognoseAttendance(isValid: boolean) {
        if (isValid) {
            this.getPrognose();
        }
    }

    private buildForm() {
        this.formGroup = new FormGroup({
            priceFormControl: new FormControl({value: this.stadium.price, disabled:!this.canSetupPrice}, [Validators.required, Validators.min(1)])
        })
    }

    private getPrognose() {
        this.isProcessing = true;
        this.attendanceService.prognoseAttendance(this.formGroup.controls.priceFormControl.value ? this.formGroup.controls.priceFormControl.value : 0, this.homeTeamId)
            .subscribe(result => {
                this.prognoseAttendance = result.attendance;
                this.prognoseRevenue = this.prognoseAttendance * (this.formGroup.controls.priceFormControl.value ? this.formGroup.controls.priceFormControl.value : 0);
                this.prognosePercent = result.percentAttendance;

                this.isProcessing = false;
            });
    }
}